export const FETCH_CAPTCHA = 'FETCH_CAPTCHA';
export const REQUEST_SMS_CODE = 'REQUEST_SMS_CODE';
export const SMS_CODE_COUNTER_RESET = 'SMS_CODE_COUNTER_RESET';
export const SMS_CODE_COUNTER_TICK = 'SMS_CODE_COUNTER_TICK';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export default {
    FETCH_CAPTCHA,
    REQUEST_SMS_CODE,
    SMS_CODE_COUNTER_RESET,
    SMS_CODE_COUNTER_TICK,
    LOGIN,
    LOGOUT,
};



// WEBPACK FOOTER //
// ./src/store/auth/types.js